/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { SystemsRequestPost } from '../../models/systems-request-post';
import { SystemsResponseGetRecordsList } from '../../models/systems-response-get-records-list';

export interface DevicesControllerGetSystems$Params {
      body: SystemsRequestPost
}

export function devicesControllerGetSystems(http: HttpClient, rootUrl: string, params: DevicesControllerGetSystems$Params, context?: HttpContext): Observable<StrictHttpResponse<SystemsResponseGetRecordsList>> {
  const rb = new RequestBuilder(rootUrl, devicesControllerGetSystems.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<SystemsResponseGetRecordsList>;
    })
  );
}

devicesControllerGetSystems.PATH = '/planning-projects/v1-preview/devices/systems';
